import { Pipe, PipeTransform } from '@angular/core';
import { marked, MarkedOptions } from 'marked';

@Pipe({
  name: 'markdown',
  pure: true,
  standalone: true,
})
export class MarkdownPipe implements PipeTransform {

  transform(value: any, options?: MarkedOptions): any {
    return value && marked.parse(value, options);
  }

}
